<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" center width="800px">
    <form-template ref="formTemplate"
                   @success="backParent"
                   @getDetailSuccess="getDetailSuccess"
                   @submit="submit"

    ></form-template>
  </el-dialog>
</template>
<script>
import formTemplate from "./formTemplate";

export default {
  components: {
    formTemplate: formTemplate
  },
  data() {
    return {
      formType: {
        other: 'other',
        insert: 'insert',// 编辑状态
        update: 'update',// 编辑状态
        search: 'search',//搜索
      },
      formOptions: null,
      title: '',
      dialogFormVisible: false,
      id: 0
    };
  },
  methods: {
    setFormOptions(operationType, id, title) {
      this.title = title || document.title;
      this.id = id || 0;
      this.dialogFormVisible = true;
      switch (operationType) {
        case this.formType.insert:
          this.formOptions = this.$store.state['ADDFORM'];
          break;
        case this.formType.update:
          this.formOptions = this.$store.state['EDEITFORM'];
          break;
        case this.formType.other:
          this.formOptions = this.$store.state['OTHERFORM'];
          break;
        default:
          console.log('没有operationType');
      }
      this.formOptions.formType = operationType;
      this.$nextTick(() => {//页面显示后操作
        this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.formOptions, id);
      });
    },
    backParent() {
      this.dialogFormVisible = false;
      this.$emit('operationSuccess');
    },
    getDetailSuccess(formModel) {
      this.formOptions.callback && this.formOptions.callback(formModel);
    },

    submit(data) {
      this.dialogFormVisible = false;
      this.$emit('submit', data);
    },
    clearForm () {
        this.dialogFormVisible = false;
        this.$refs['formTemplate'].resetForm();
      }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/add.vue